import './index.scss'

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Subscription from '@ui-pc/Subscription'
import Switch from '@ui-pc/Switch'

interface Props {
  showSubscribe?
  onOpen?
}

const CouponReg: React.FC<Props> = ({ showSubscribe, onOpen }) => {
  const dispatch = useDispatch()
  const newUserCoupon = useSelector(
    (state: any) => state.app.newUserCouponPackAmount
  )
  const couponInfo = useSelector((state: any) => state.app.couponInfo)

  const showLoginModal = () => {
    dispatch({
      type: 'login/triggleLogin',
      payload: true
    })
  }

  // 如果不显示订阅券，且新用户券没数据，则返回空
  if (!showSubscribe && !newUserCoupon) {
    return <></>
  }

  return (
    <section className="coupon-reg-item">
      <div className="coupon-box coupon-box-reg">
        <div className="box-coupon">
          <span className="box-text">
            {showSubscribe ? couponInfo?.subscribeCoupon : newUserCoupon} OFF
          </span>
          <span className="new-label">
            {showSubscribe ? 'Subscriber' : 'New Users'}
          </span>
          <span className="desc-order">No min. spend</span>
        </div>
        <div className="coupon-desc-right">
          <span className="new-user-tip">
            {showSubscribe
              ? 'Coupon for New Subscribers'
              : 'Coupon Packets for New Users'}
          </span>
          <Switch either={showSubscribe}>
            <a
              className="sign-get-sub"
              onClick={() => {
                Subscription.open()
                onOpen?.()
              }}>
              Get Now
            </a>
            <a className="sign-get" onClick={showLoginModal}>
              Sign in to Get
            </a>
          </Switch>
        </div>
      </div>
    </section>
  )
}

export default CouponReg
